var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSigNozLogoOrange = function SvgSigNozLogoOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h21v22H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    y: 0.5,
    fill: "url(#SigNozLogo-orange_svg__a)",
    rx: 4.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#SigNozLogo-orange_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.31 10.988v-.005l.002-.008.022-.088q.022-.082.073-.225c.069-.188.182-.448.364-.76.363-.623.998-1.445 2.089-2.3a9.3 9.3 0 0 1 2.957-1.569A7 7 0 0 1 8.78 5.8a5 5 0 0 1 .377-.048h.009l.001-.001.028.466.028.465-.065.006q-.076.008-.225.033a6 6 0 0 0-.72.169c-.576.197-1.4.583-2.362 1.336-.96.751-1.5 1.46-1.798 1.972a4 4 0 0 0-.29.607A2 2 0 0 0 3.7 11l.01.036q.013.054.051.16c.052.142.141.35.29.607.3.512.839 1.221 1.799 1.972.962.753 1.786 1.139 2.362 1.336l.027.01c.286.082.523.13.693.16a4 4 0 0 0 .29.038l-.028.465-.028.466h-.01l-.1-.01a5 5 0 0 1-.277-.04 7 7 0 0 1-.963-.233 9.3 9.3 0 0 1-2.957-1.57c-1.091-.854-1.726-1.676-2.09-2.3a5 5 0 0 1-.363-.76 3 3 0 0 1-.095-.312l-.001-.008-.001-.003v-.026m16.381 0v-.002l-.001-.003-.002-.008a2 2 0 0 0-.095-.313 5 5 0 0 0-.363-.76c-.364-.623-.998-1.445-2.09-2.3a9.3 9.3 0 0 0-2.957-1.569 7 7 0 0 0-.963-.234 5 5 0 0 0-.376-.048h-.01l-.001-.001-.028.466-.028.465.011.001.054.005q.076.008.225.033a6 6 0 0 1 .72.169c.577.197 1.4.583 2.362 1.336.96.751 1.5 1.46 1.799 1.972.149.257.238.466.29.607a2 2 0 0 1 .061.196l-.01.036q-.013.054-.051.16c-.052.142-.141.35-.29.607-.299.512-.839 1.221-1.799 1.972-.962.753-1.785 1.139-2.362 1.336l-.027.01a6 6 0 0 1-.693.16 4 4 0 0 1-.29.038l.028.465.028.466h.011l.1-.01q.1-.01.276-.04c.235-.04.566-.11.963-.233a9.3 9.3 0 0 0 2.957-1.57c1.092-.854 1.726-1.676 2.09-2.3.181-.31.294-.571.363-.76a3 3 0 0 0 .095-.312l.002-.008v-.029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.351 11c0 2.067-1.664 3.743-3.717 3.743S6.918 13.067 6.918 11s1.664-3.744 3.716-3.744S14.352 8.932 14.352 11M9.705 8.894s-.446.526-.58.936c-.087.264-.117.702-.117.702H7.847s0-.351.232-.936.465-.702.465-.702zm-.58 3.275c.134.41.58.936.58.936H8.544s-.233-.117-.465-.702-.232-.936-.232-.936h1.161s.03.439.116.702"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SigNozLogo-orange_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45.69 -7.805 17.962)scale(12.3258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF5E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2929"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "SigNozLogo-orange_svg__b",
    width: 18.9,
    height: 13.02,
    x: 1.05,
    y: 5.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.63
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.368384 0 0 0 0 0.0623777 0 0 0 0 0.0623777 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2420_727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2420_727",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.63
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_2420_727"
  })))));
};
export default SvgSigNozLogoOrange;